import { Component } from 'react';
import APP from 'stores/APP';

interface TitleProps {
    title: string;
    noSuffix?: boolean;
}

class Title extends Component<TitleProps> {
    // 如果是App嵌入的，不需要加TradeUp
    componentDidMount() {
        document.title = this.props.title + (APP.isTiger || this.props.noSuffix ? '' : ' - TradeUP');
    }

    render() {
        return null;
    }
}

export default Title;
